export default function linkValueFormatter(params) {
  var value = params.value
  if (value) {
    return value.replace( /(<([^>]+)>)/ig, "")
  } else {
    return "(Blanks)"
  }
}
